export default "__VITE_ASSET__PiHy9sKg__"